import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

import classes from "./SamlLoginForm.scss";

import {FormTextInput} from "UIComponents/InputTextField";
import { Button, Modal } from "@toddle-edu/ds-web";

import {
  setIdpsList,
  getSamlBackendRedirectUrl,
} from "Login/modules/LoginModule";

class LoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.inputRefs = {};
  }

  componentDidMount = () => {
    this.inputRefs?.schoolcode?.focus();
  };

  onBackClick = () => {
    const { updateCurrentScreen, userType, updateInputField } = this.props;

    updateInputField({});

    switch (userType) {
      case "staff":
        updateCurrentScreen({ type: "teacherLogin" });
        break;
      case "student":
        updateCurrentScreen({ type: "studentLogin" });
        break;
      case "parent":
        updateCurrentScreen({ type: "parentLogin" });
        break;
    }
  };

  onSignInClick = async () => {
    const {
      updateInputField,
      data: { schoolcode },
      onSamlSignInClick,
      showErrorToast,
    } = this.props;

    updateInputField({
      schoolcode: _.trim(schoolcode),
    });

    const errorCount = this.isValid();

    showErrorToast({ errorCount });

    if (errorCount > 0) {
      return;
    }

    onSamlSignInClick();
  };

  isValid = () => {
    const refKeys = _.keys(this.inputRefs);

    let errorCount = 0;

    _.forEach(refKeys, key => {
      if (this.inputRefs[key]) {
        errorCount += this.inputRefs[key].isValid();
      }
    });

    return errorCount;
  };

  getBackButtonText = () => {
    const { userType, role, isNewLoginFlowEnabled } = this.props;
    if (isNewLoginFlowEnabled) {
      return "Go back";
    }
    switch (userType) {
      case "student":
        return "Student account";
      case "staff":
        if (role === "visitor") return "Visitor account";
        return "Teacher account";
    }
  };

  getHeaderText = () => {
    const { userType, role } = this.props;
    switch (userType) {
      case "student":
        return "Student account";
      case "staff":
        if (role === "visitor") return "Visitor account";
        return "Teacher account";
      case "parent":
        return "Family account";
    }
  };

  closeIdpListModal = () => {
    this.props.setIdpsList([]);
  };

  onIdpSelected = idp => {
    const {
      userType,
      data: { schoolcode: schoolCode },
    } = this.props;

    const url = getSamlBackendRedirectUrl({
      region: idp.region,
      idpId: idp.id,
      userType,
      schoolCode,
    });

    window.location.replace(url);
  };

  render() {
    const {
      updateInputField,
      checkEmailVerification,
      data: { schoolcode },
      renderBackButtonComponent,
      customStyle: { containerStyle, headerStyleV2 } = {},
      currentIdpsList,
    } = this.props;
    return (
      <div className={classes.container} style={containerStyle}>
        {renderBackButtonComponent({
          onClick: this.onBackClick,
          buttonText: this.getBackButtonText(),
        })}
        <div style={headerStyleV2}>{this.getHeaderText()}</div>
        <div className={classes.innerContainer}>
          <div className={classes.inputContainer}>
            <FormTextInput
              data-test-id="input-login-schoolcode"
              ref={ref => (this.inputRefs["schoolcode"] = ref)}
              textInputLabel={"School code*"}
              value={schoolcode}
              name={"schoolcode"}
              placeholder={"Enter your school code"}
              updateInputField={updateInputField}
              error={"Enter school code"}
              size={"large"}
              autoComplete={"off"}
            />
          </div>
          <div className={classes.bottomContainer}>
            <Button
              data-test-id="button-sign-in"
              variant={"destructive"}
              size={"large"}
              onClick={this.onSignInClick}
              isFullWidth={true}
            >
              {"Sign in"}
            </Button>
          </div>
        </div>
        {currentIdpsList.length > 1 && (
          <Modal
            width="360px"
            height="max-content"
            onClose={this.closeIdpListModal}
            isOpen={true}
          >
            <Modal.Header title={"Select your IDP to continue"} isClosable />
            <Modal.Body>
              <div className={classes.idpListContainer}>
                {_.map(currentIdpsList, idp => {
                  return (
                    <Button
                      key={idp}
                      data-test-id="button-select-idp"
                      variant={"outlined"}
                      size={"large"}
                      onClick={() => {
                        this.onIdpSelected(idp);
                      }}
                      isFullWidth={true}
                    >
                      {idp.name}
                    </Button>
                  );
                })}
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const loginDataState = _.get(state, "login", {});

  return {
    currentIdpsList: _.get(loginDataState, "currentIdpsList", []),
  };
};

const mapActionCreators = {
  setIdpsList,
};

export default compose(connect(mapStateToProps, mapActionCreators))(LoginForm);
